import DataMapper from './DataMapper'
import HospitalRM from '../responsemodel/HospitalRM'
import Hospital from '../../models/Hospital'

export default class HospitalDataMapper extends DataMapper<HospitalRM, Hospital> {
  map = (rm: HospitalRM) => new Hospital(rm.id, rm.name, rm.district, rm.state)
}
